export default __webpack_public_path__ + "static/media/Background_00247.974fd47a.png";